module.exports = __webpack_public_path__ + "static/chauntea-symbol-DND3_FnP-8dcd44d1a20c05c8b0d363b30a172f50.webp";